// src/config/firebase-config.js
// This file ONLY sets up Firebase - it doesn't change any existing functionality

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBrRg09vmV2dddqwYtlVTlktMyQDRRyppU",
  authDomain: "divine-frameworks-6cb16.firebaseapp.com",
  projectId: "divine-frameworks-6cb16",
  storageBucket: "divine-frameworks-6cb16.firebasestorage.app",
  messagingSenderId: "1051467444535",
  appId: "1:1051467444535:web:3d70fd81136364dc08aab2"
};

// Initialize Firebase only once
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  // Don't crash the app if Firebase fails
  app = null;
}

// Export Firebase services (will be null if initialization fails)
export const auth = app ? getAuth(app) : null;
export const db = app ? getFirestore(app) : null;
export const storage = app ? getStorage(app) : null;

// Export initialization status
export const isFirebaseInitialized = () => {
  return app !== null;
};

// Test function to verify Firebase is working
export const testFirebaseConnection = async () => {
  try {
    if (!app) {
      return { success: false, message: 'Firebase not initialized' };
    }
    
    // Try to access Firestore with v9 syntax
    if (db) {
      // This doesn't actually write anything, just tests the connection
      const testDocRef = doc(db, '_test', '_test');
      await getDoc(testDocRef).catch(() => {});
      return { success: true, message: 'Firebase connected successfully!' };
    }
    
    return { success: false, message: 'Firestore not available' };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export default app;